import { PropsWithChildren } from 'react';

import { useModalProviderInit } from './hooks';
import { ModalContext } from './modal.context';

export const ModalProvider = ({ children }: PropsWithChildren<unknown>) => {
  const context = useModalProviderInit();
  return <ModalContext.Provider value={context}>{children}</ModalContext.Provider>;
};
